/**
 * @param hierarchy
 * @return {{}}
 */
export const getHierarchy = ({ hierarchy }) => {
  return hierarchy;
};
